import React from 'react';
import Modal from 'react-responsive-modal';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS } from '../../utils/log';
import FormattedDate from '../fields/dates/FormattedDate';

export const MODULE_NAME = 'ACTION_MODAL';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

const MODAL_CLASSNAMES = {
    modal: 'modal-max-width-75',
};

const ActionsModal = (props) => {
    if (props.modalCountriesOnHold) {

        const onDateSelectHandler = (value) => {
            log.debug("onDateSelectHandler", value);
            props.lockDate(value);
        };

        const humanReadableAction = (
            <span>
                {props.action === 'UnlockFinancial' ? <LanguageStringResolver string="countriesOnHold_UnlockFinancialData" /> : ''}
                {props.action === 'LockFinancial' ? <LanguageStringResolver string="countriesOnHold_LockFinancialData" /> : ''}
                {props.action === 'UnlockLogistical' ? <LanguageStringResolver string="countriesOnHold_UnlockLogisticalData" /> : ''}
                {props.action === 'LockLogistical' ? <LanguageStringResolver string="countriesOnHold_LockLogisticalData" /> : ''}
                {props.action === 'UnlockBoth' ? <LanguageStringResolver string="countriesOnHold_UnlockBothLong" /> : ''}
                {props.action === 'LockBoth' ? <LanguageStringResolver string="countriesOnHold_LockBothLong" /> : ''}
                {props.action === 'LockAll' ? <LanguageStringResolver string="countriesOnHold_LockAll" /> : ''}
                {props.action === 'UnlockAll' ? <LanguageStringResolver string="countriesOnHold_UnlockAll" /> : ''}
            </span>
        );

        return (
            <Modal
                classNames={MODAL_CLASSNAMES}
                open={props.open}
                onClose={props.onCloseModal}
                center
                data-test="component-countries-on-hold-actions-modal"
            >
                <h2 className="mt0">
                    {humanReadableAction} <LanguageStringResolver string="countriesOnHold_Confirmation" />
                </h2>
                <div>
                    <p>
                        <LanguageStringResolver string="countriesOnHold_ActionToTake" /> <span className="lowercase">{humanReadableAction}</span>,{' '}
                        <LanguageStringResolver string="countriesOnHold_AreYouSure" />
                    </p>
                    <h3>
                        <LanguageStringResolver string="countriesOnHold_CountriesAffected" />
                    </h3>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <LanguageStringResolver string="countriesOnHold_Country" />
                                </th>
                                <th>
                                    <LanguageStringResolver string="countriesOnHold_FinancialData" />
                                </th>
                                <th>
                                    <LanguageStringResolver string="countriesOnHold_LogisticalData" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.modalCountriesOnHold
                                ? props.modalCountriesOnHold
                                      .map((country) =>
                                          Object.assign(
                                              {},
                                              country,
                                              props.countryMappings.find((c) => c.countryCode === country.countryCode)
                                          )
                                      )
                                      .map((country) => {
                                          return (
                                              <tr key={country.countryCode}>
                                                  <td>
                                                      <span key={country.countryCode}>
                                                          {country.countryName} ({country.countryCode})
                                                      </span>
                                                  </td>
                                                  <td>
                                                      {props.action === 'UnlockFinancial' || props.action === 'UnlockBoth' ? (
                                                          <span className="bold">
                                                              <LanguageStringResolver string="countriesOnHold_ThisWillBeUnlocked" /> -{' '}
                                                          </span>
                                                      ) : (
                                                          ''
                                                      )}
                                                      {props.action === 'LockFinancial' || props.action === 'LockBoth' ? (
                                                          <span className="bold">
                                                              <LanguageStringResolver string="countriesOnHold_ThisWillBeLocked" /> -{' '}
                                                          </span>
                                                      ) : (
                                                          ''
                                                      )}
                                                      {country.onHold.financialDataOnHoldFrom === '' ? (
                                                          <span>
                                                              {props.action === 'LockAll' ? (
                                                                  <span className="bold">
                                                                      <LanguageStringResolver string="countriesOnHold_ThisWillBeLocked" /> -{' '}
                                                                  </span>
                                                              ) : (
                                                                  ''
                                                              )}
                                                              <LanguageStringResolver string="countriesOnHold_Unlocked" />
                                                          </span>
                                                      ) : (
                                                          <span>
                                                              {props.action === 'UnlockAll' ? (
                                                                  <span className="bold">
                                                                      <LanguageStringResolver string="countriesOnHold_ThisWillBeUnlocked" /> -{' '}
                                                                  </span>
                                                              ) : (
                                                                  ''
                                                              )}
                                                              <LanguageStringResolver string="countriesOnHold_LockedFrom" />{' '}
                                                              {country.onHold.financialDataOnHoldFrom}
                                                          </span>
                                                      )}
                                                  </td>
                                                  <td>
                                                      {props.action === 'UnlockLogistical' || props.action === 'UnlockBoth' ? (
                                                          <span className="bold">
                                                              <LanguageStringResolver string="countriesOnHold_ThisWillBeUnlocked" /> -{' '}
                                                          </span>
                                                      ) : (
                                                          ''
                                                      )}
                                                      {props.action === 'LockLogistical' || props.action === 'LockBoth' ? (
                                                          <span className="bold">
                                                              <LanguageStringResolver string="countriesOnHold_ThisWillBeLocked" /> -{' '}
                                                          </span>
                                                      ) : (
                                                          ''
                                                      )}
                                                      {country.onHold.logisticalDataOnHoldFrom === '' ? (
                                                          <span>
                                                              {props.action === 'LockAll' ? (
                                                                  <span className="bold">
                                                                      <LanguageStringResolver string="countriesOnHold_ThisWillBeLocked" /> -{' '}
                                                                  </span>
                                                              ) : (
                                                                  ''
                                                              )}
                                                              <LanguageStringResolver string="countriesOnHold_Unlocked" />
                                                          </span>
                                                      ) : (
                                                          <span>
                                                              {props.action === 'UnlockAll' ? (
                                                                  <span className="bold">
                                                                      <LanguageStringResolver string="countriesOnHold_ThisWillBeUnlocked" /> -{' '}
                                                                  </span>
                                                              ) : (
                                                                  ''
                                                              )}
                                                              <LanguageStringResolver string="countriesOnHold_LockedFrom" />{' '}
                                                              {country.onHold.logisticalDataOnHoldFrom}
                                                          </span>
                                                      )}
                                                  </td>
                                              </tr>
                                          );
                                      })
                                : ''}
                        </tbody>
                    </table>
                    <span>
                        {props.action === 'LockFinancial' || props.action === 'LockLogistical' || props.action === 'LockAll' ? (
                            <span></span>
                        ) : props.modalCountriesOnHold.reduce((shouldShowWarning, country) => shouldShowWarning || country.onHold.showWarningOnUnlock, false) ? (
                            <span>
                                <s-alert className="mt10 mb10" status="warn" dismissible="false">
                                {props.action === 'UnlockAll' || props.action === 'LockAll' ? (
                                    <p><LanguageStringResolver string="countriesOnHold_CountryListLocked" /></p>
                                ) : (
                                    <p><LanguageStringResolver string="countriesOnHold_CountryLocked" /></p>
                                )}
                                    <ul className="ml20">
                                        {props.modalCountriesOnHold
                                            .filter((country) => country.onHold.showWarningOnUnlock === true)
                                            .map((country) =>
                                                Object.assign(
                                                    {},
                                                    country,
                                                    props.countryMappings.find((c) => c.countryCode === country.countryCode)
                                                )
                                            )
                                            .map((country) => (
                                                <li key={country.countryCode}>
                                                    <span>
                                                        {country.countryName} ({country.countryCode})
                                                    </span>
                                                </li>
                                            ))}
                                    </ul>
                                    {props.action === 'UnlockAll' || props.action === 'LockAll' ? (
                                        <p>
                                            <LanguageStringResolver string="countriesOnHold_UnlockAllWarning" />
                                        </p>
                                    ) : (
                                        <p data-test="countries-on-hold-warning">
                                            <LanguageStringResolver string="countriesOnHold_UnlockWarning" />
                                        </p>
                                    )}
                                </s-alert>
                                <br />
                            </span>
                        ) : (
                            <span></span>
                        )}
                    </span>
                    {props.action === 'LockFinancial' || props.action === 'LockLogistical' || props.action === 'LockBoth' || props.action === 'LockAll' ? (
                        <fieldset>
                            <h3 className="mb10">
                                <LanguageStringResolver string="countriesOnHold_ApplyLock" />
                            </h3>
                            <label htmlFor="date-input">
                                <LanguageStringResolver string="countriesOnHold_EffectiveFrom" />
                            </label>

                            <s-row>
                                <s-col span="6">
                                    <FormattedDate
                                        editOptions={{
                                            fieldName: 'date',
                                            format: 'yyyy-mm-dd',
                                            changeHandler: onDateSelectHandler
                                        }}
                                        value={props.date}
                                    />
                                </s-col>
                            </s-row>
                            
                        </fieldset>
                    ) : (
                        <span></span>
                    )}
                    <button onClick={props.unlockOrLockCountryHandler} className="primary mr10">
                        <LanguageStringResolver string="countriesOnHold_Continue" />
                    </button>
                    <button onClick={props.onCloseModal} className="secondary">
                        <LanguageStringResolver string="countriesOnHold_Cancel" />
                    </button>
                </div>
            </Modal>
        );
    } else {
        return null;
    }
};

export default ActionsModal;
